<template>
    <div class="aba-produto select-modal">
        <div class="vertical-flow">
            <div class="columns">
                <div class="column">
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-licenca-restricao"
                    />
                </div>
                <div class="column" :class="[permissao.create ? 'is-2' : 'is-3']">
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>
                <div class="column is-3" v-if="permissao.create && !integracao">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalVincularLicenca"
                    >
                        {{ $t('vincular-licenca') }}
                    </button>
                </div>
                <div class="column is-3" v-if="permissaoLicenca.create && !licencaIntegracao">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalCadastroLicenca = !showModalCadastroLicenca"
                    >
                        {{ $t('adicionar-licenca') }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <container-loader v-if="isLoading && !$store.getters.isLoading" />
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assprodutolicenca"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'situacao-licenca'">
                            {{ $t(props.row['situacao-licenca'] == 1 ? 'ativo' : 'inativo') }}
                        </div>
                        <div v-else-if="f.key == 'bloqueiavenda'">
                            {{ $t(props.row['bloqueiavenda'] == 1 ? 'sim' : 'nao') }}
                        </div>
                        <div v-else-if="f.key == 'excluir'">
                            <b-button
                                v-if="permissao.delete && !integracao"
                                class="action-button"
                                :type="
                                    props.row['replicapda'] == 3
                                        ? 'is-danger'
                                        : 'is-success'
                                "
                                :icon-right="
                                    props.row['replicapda'] == 3 ? 'delete' : 'check'
                                "
                                @click="promptChangeSituacao(props.row)"
                                v-tippy 
                                :title="$t(props.row['replicapda'] == 3 ? 'desativar' : 'reativar')"
                            />
                        </div>
                        <div v-else-if="f.key == 'replicapda'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                :type="props.row['replicapda'] == 3 ? 'is-success' : 'is-danger'"
                                size="is-medium"
                            >
                                {{ $t(props.row['replicapda'] == 3 ? 'ativo' : 'inativo') }}
                            </b-tag>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao">
                <div class="bg">
                    <LicencaModal :idProduto="$route.params.id" @fecharModal="fecharModal" />
                </div>
            </b-modal>

            <!-- MODAL DE CADASTRO -->
            <b-modal :active.sync="showModalCadastroLicenca">
                <div>
                    <LicencaCadastroModal
                        @fecharModal="fecharModal"
                        @cadastrado="cadastradaLicenca"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import AssProdutoLicencaService from '@/services/vendas/produto/AssProdutoLicencaService';
import LicencaModal from '@/components/vendas/produto/modal/dados-cadastrais/licenca/LicencaModal.vue';
import LicencaCadastroModal from '@/components/vendas/produto/modal/dados-cadastrais/licenca/LicencaCadastroModal.vue';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import HideInfo from '@/components/shared/HideInfo';
import { mapState } from 'vuex';

export default {
    components: {
        ContainerLoader,
        LicencaModal,
        LicencaCadastroModal,
        HideInfo,
    },
    data() {
        return {
            assprodutolicenca: [],
            cleanHide: true,
            fields: [
                { key: 'descricao', width: null, sortable: true, sortFn: null },
                { key: 'situacao-licenca', width: 100, sortable: true, sortFn: null },
                { key: 'bloqueiavenda', width: 100, sortable: true, sortFn: null },
                { key: 'replicapda', width: 70, sortable: true, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],

            service: new AssProdutoLicencaService(this.$http, this.$router),
            permissao: false,
            permissaoLicenca: false,
            integracao: this.$store.state.user.tabelasERPWebServer.includes('ASSPRODUTOLICENCA'),
            licencaIntegracao: this.$store.state.user.tabelasERPWebServer.includes('LICENCA'),
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'descricao',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModalAssociacao: false,
            showModalCadastroLicenca: false,
            situacaoSelect: [
                { id: 4, label: 'todos' },
                { id: 3, label: 'ativos' },
                { id: 2, label: 'inativos' },
            ],
            situacaoSelected: { id: 4, label: 'todos' },
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess(
            'vendas',
            'produtos',
            'ven-produto-dados-cadastrais-licenca'
        );

        this.permissaoLicenca = this.hasPermissionAccess('vendas', 'produtos', 'licencas');

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'aba-licenca' },
            });

        this.carregarDados();
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', { infoIsHidden: !this.hide.infoIsHidden });
        },
        carregarDados(currentPage = 1) {
            this.cleanHide = true;
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;
            this.service
                .findByIdProduto(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.$route.params.id,
                    this.situacaoSelected.id,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.assprodutolicenca = value;
                    this.isEmpty = this.assprodutolicenca.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os usuários!');
                    console.error(e);
                })
                .finally((_) => {
                    this.cleanHide = false;
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idassprodutolicenca: m.idassprodutolicenca,
                    descricao: m.licenca.descricao,
                    'situacao-licenca': m.licenca.status,
                    bloqueiavenda: m.licenca.bloqueiavenda,
                    replicapda: m.replicapda,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.replicapda == 3
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row['descricao'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure = this.$t(
                    this.delete.replicapda == 3
                        ? 'msg-erro-ao-reativar-n'
                        : 'msg-erro-ao-desativar-n', 
                    { n: this.$t('licenca') }
                );

            let tempAssProdutoLicenca = {
                idassprodutolicenca: this.delete.idassprodutolicenca,
                replicapda: this.delete.replicapda == 3 ? 2 : 3,
            };

            this.isLoading = true;
            this.service
                .updateSituacao(tempAssProdutoLicenca)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess = this.$t(
                                r.content.replicapda == 3
                                    ? 'msg-sucesso-ao-reativar-n'
                                    : 'msg-sucesso-ao-desativar-n', 
                                { n: this.$t('licenca') }
                            );
                        this.$root.showMessage('success', tempSuccess, true, false);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar situacao-licenca.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar situacao-licenca.', e);
                    this.$root.showMessage('error', tempFailure, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        showModalVincularLicenca() {
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        fecharModal() {
            this.showModalAssociacao = false;
            this.isUpdate = false;
            this.showModalCadastroLicenca = false;
            this.carregarDados();
        },
        cadastradaLicenca(licenca) {
            this.showModalCadastroLicenca = false;
            this.isUpdate = false;
            this.showModalAssociacao = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-produto {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
